/**
 * Platform display name: companyShort-realName-position
 */
export function formatUserDisplayName(user) {
  if (!user) return 'Unknown'
  if (user.isGroup) return user.name || 'Group'
  if (user.system_name) return user.system_name

  const parts = [
    user.company_short_name || user.companyShortName,
    user.real_name || user.realName,
    user.position,
  ].filter((part) => part != null && String(part).trim())

  if (parts.length) return parts.join('-')
  if (user.name && !String(user.name).includes(user.company_full_name || '')) {
    return user.name
  }
  return user.name || 'Unknown'
}

/** @deprecated use formatUserDisplayName — kept for chat contact rows */
export function formatContactDisplayName(contact) {
  return formatUserDisplayName(contact)
}
